import React from 'react'
import '../index.css'

const SkeletonCard = () => {
  return (
    <div className='rifter-card-container skeleton-card'>
      <div className='image-container'>
        <div className='skeleton-image'></div>
      </div>
      <div className='rifter-info'>
        <div className='skeleton-line skeleton-title'></div>
        <div className='skeleton-line skeleton-subtitle'></div>
        <div className='skeleton-line skeleton-text'></div>
        <div className='skeleton-line skeleton-text-short'></div>
        <div className='skeleton-tags'>
          <div className='skeleton-tag'></div>
          <div className='skeleton-tag'></div>
          <div className='skeleton-tag'></div>
        </div>
      </div>
    </div>
  )
}

export default SkeletonCard
